import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // useEffect(() => {
  //   const currentLang = i18n.language;
  //   const direction = currentLang === "ar" ? "rtl" : "ltr";
  //   document.documentElement.setAttribute("dir", direction);
  //   document.documentElement.setAttribute("lang", currentLang);
  // }, [i18n.language]);

  return (
    <>
      <div className="privacy-bg from-top">
        <Header />

        <div className="heading-policy flex-column text-center">
          <h1>Privacy Policy</h1>
        </div>
      </div>

      <div className="container data-info">
        <div className="text-center">
          <p>
            Website: <a href="https://bazarnauae.com">https://bazarnauae.com</a>
          </p>
        </div>
        <div className="privacy-heading">
          <p>
            This Privacy Policy describes how <strong>Bazarna</strong>, registered in the United Arab Emirates (UAE), collects, uses, and safeguards the personal information of users who use the <strong>Bazarna</strong> mobile application and website (<a href="https://bazarnauae.com">https://bazarnauae.com</a>). We are committed to protecting the privacy and confidentiality of all information entrusted to us. By accessing or using our application, you consent to the collection, use, and disclosure of your personal information as described below.
          </p>

          <h3 className="mt-5">1. Information We Collect</h3>

          <h4 className="mt-4">1.1 Personal Information</h4>
          <p>
            When you register or interact with Bazarna, we may collect the following personal details:
          </p>
          <ul>
            <li>Full name, profile picture, and gender</li>
            <li>Email address and phone number</li>
            <li>Login credentials, or your Google/Apple account identifier if you sign in that way</li>
          </ul>

          <h4 className="mt-4">1.2 Seller & Store Information</h4>
          <p>If you register as a Seller, we additionally collect:</p>
          <ul>
            <li>Store name, logo, cover photos, and store description</li>
            <li>Business address and map location (for commercial Sellers, this may include a trade licence)</li>
            <li>Bank account details, used solely to process your payouts</li>
          </ul>

          <h4 className="mt-4">1.3 Marketplace & Order Information</h4>
          <p>
            We collect information about the Listings you create, browse, or order, including product photos and descriptions, order history, delivery address, order status and tracking, promo codes used, and any ratings or reviews you leave.
          </p>

          <h4 className="mt-4">1.4 Location Information</h4>
          <p>
            We collect location data you provide for Seller storefronts and for Food Fridges you add to the map, so that other Users can find them nearby.
          </p>

          <h4 className="mt-4">1.5 Payment Information</h4>
          <p>
            Card and Apple Pay payments are processed by our third-party payment processor (Stripe). We do not store your full card details on our servers; we retain only the transaction and payment method reference needed to manage your orders.
          </p>

          <h4 className="mt-4">1.6 Device & Usage Information</h4>
          <p>
            We collect your device type and a device token used to send push notifications about your orders, messages, and offers, along with general app usage information to help us maintain and improve the Service.
          </p>

          <h3 className="mt-5">2. Use of Information</h3>
          <p>We use the collected information to:</p>
          <ul>
            <li>Create and manage your Bazarna account, including Seller store approval</li>
            <li>Process orders, payments, payouts, and deliveries</li>
            <li>Display Seller storefronts and Food Fridge locations on the map</li>
            <li>Show relevant ratings, reviews, and promo codes</li>
            <li>Improve and personalize user experience</li>
            <li>Respond to inquiries and send order or account notifications</li>
            <li>Ensure compliance with UAE data and content regulations</li>
            <li>Detect and prevent fraud or misuse</li>
          </ul>

          <h3 className="mt-5">3. Sharing With Third Parties & Other Users</h3>
          <p>
            We share information only as needed to provide the Service:
          </p>
          <ul>
            <li>With Sellers or Buyers directly involved in an order, so they can fulfil and deliver it</li>
            <li>With our payment processor (Stripe) to process card and Apple Pay payments</li>
            <li>With delivery partners, to dispatch and track your order</li>
            <li>With Google or Apple, if you choose to sign in using those services</li>
          </ul>
          <p className="mt-3">
            We do not sell your personal information to third parties.
          </p>

          <h3 className="mt-5">4. Data Security</h3>
          <p>
            We apply strong administrative, technical, and physical safeguards to protect your personal information from unauthorized access or disclosure. While we strive for the highest security standards, no method of online transmission or storage is completely secure, and we cannot guarantee absolute protection.
          </p>

          <h3 className="mt-5">5. Data Retention</h3>
          <p>
            We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law. When information is no longer needed, it is securely deleted or anonymized.
          </p>

          <h3 className="mt-5">6. Your Rights</h3>
          <p>
            In accordance with <strong>UAE Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL)</strong>, you have the right to:
          </p>
          <ul>
            <li>Access your personal information</li>
            <li>Request correction or deletion</li>
            <li>Withdraw consent for data processing</li>
            <li>Object to certain processing activities</li>
          </ul>
          <p className="mt-3">
            To exercise these rights, contact us using the details provided below.
          </p>

          <h3 className="mt-5">7. Changes to This Privacy Policy</h3>
          <p>
            We may modify this Privacy Policy periodically. Updates will be posted in the app and on <a href="https://bazarnauae.com">https://bazarnauae.com</a> with a revised "Effective Date." We encourage users to review the policy regularly to stay informed about how we protect personal data.
          </p>

          <h3 className="mt-5">8. Contact Us</h3>
          <p>
            If you have any questions, requests, or concerns regarding this Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Bazarna FZ-LLC</strong>
          </p>
          <p>Business Bay, Dubai, United Arab Emirates</p>
          <p>
            📧 <strong>info@bazarnauae.com</strong>
          </p>
          <p>
            🌐 <a href="https://bazarnauae.com">https://bazarnauae.com</a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default PrivacyPolicy;